export default "Kan I balancere med gløden og gøre Ask kunsten efter? I denne stafet udfordres I på balance, fart og gruppesamarbejde.";